/**
 * @file Règle de saisie des allergies : « Oui » exige des détails exploitables.
 * @module packages.common.utils.restaurant.allergyDetailsRule
 *
 * Source unique partagée par toutes les surfaces : parcours de réservation
 * (widget embarqué, site public, liste d'attente), page publique de gestion et
 * backoffice (création et modification). Une déclaration « Oui » sans détail
 * n'est pas exploitable en cuisine : elle alerte sans dire sur quoi, ce qui est
 * pire qu'une absence d'information. Le backend applique la même règle
 * partout, avec le code `ALLERGY_DETAILS_REQUIRED`.
 *
 * Pas de longueur minimale : « œuf » fait trois caractères et « soja » quatre.
 * Tout minimum arbitraire finirait par rejeter une saisie légitime. On supprime
 * le vide, on ne juge pas le contenu.
 */

/** Clé i18n du message de blocage, partagée pour que les surfaces ne divergent pas. */
export const ALLERGY_DETAILS_ERROR_KEY = 'widgets.reservation.validation.allergyDetailsRequired';

/** Message de blocage du backoffice, en français comme le reste du dashboard. */
export const ALLERGY_DETAILS_BACKOFFICE_MESSAGE = 'Précisez les allergies';

/**
 * Indique si la déclaration d'allergies est exploitable.
 *
 * Accepte directement les valeurs de formulaire des surfaces, qui portent ces
 * deux noms de champ, mais le contrat ne dépend que des deux champs eux-mêmes.
 *
 * @param {Object} [values] - État à juger
 * @param {boolean} [values.hasAllergies] - Réponse à la question allergies
 * @param {string} [values.allergyDetails] - Détails saisis
 * @return {boolean} false uniquement si « Oui » est coché sans aucun détail
 */
export function isAllergyDeclarationComplete({hasAllergies, allergyDetails} = {}) {
  if (!hasAllergies) return true;
  return (allergyDetails || '').trim().length > 0;
}
